import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Book16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14 1.75L4 1.75C3.58581 1.75 3.25003 2.08575 3.25 2.49994C3.25033 2.91387 3.58599 3.25 4 3.25L13.5 3.24994C13.9142 3.24994 14.25 3.58572 14.25 3.99994V14.9999C14.25 15.4142 13.9142 15.7499 13.5 15.7499H4.5C2.98122 15.7499 1.75 14.5187 1.75 12.9999V2.5C1.75003 1.25739 2.75738 0.250004 4 0.250003L14 0.25V1.75ZM3.25 12.9999V4.62197C3.48458 4.70488 3.73702 4.75 4 4.75L9 4.75V8L10 7L11 8V4.75L12.75 4.74994V14.2499H4.5C3.80964 14.2499 3.25 13.6903 3.25 12.9999Z'
      fill='currentColor'
    />
  </Svg>
);

Book16.displayName = 'Book16';
export default Book16;
